import {
  BooleanParam,
  DateTimeParam,
  NumberParam,
  StringParam,
  withDefault,
} from 'use-query-params';

import { RgCraV2RiskHistoryOrderBy } from '@/globalTypes';
import {
  RgV2EventTypeParam,
  RgV2RiskHistoryOrderByParam,
} from '@/utils/query/params';

/**
 * Prefixed with `legacy` so this block can live on the same page as the
 * non-legacy risk assessment history block without sharing its
 * cursors/filters.
 */
export const queryParams = {
  legacyAfter: StringParam,
  legacyBefore: StringParam,
  legacyDesc: withDefault(BooleanParam, true),
  legacyEventType: RgV2EventTypeParam,
  legacyFirst: withDefault(NumberParam, 20),
  legacyFrom: DateTimeParam,
  legacyLast: NumberParam,
  legacyOrderBy: withDefault(
    RgV2RiskHistoryOrderByParam,
    RgCraV2RiskHistoryOrderBy.processedAt,
  ),
  legacyTo: DateTimeParam,
};
